import { api, WorkspacesAPITagType } from '@/api/api'
import {
  FetchFeedbackAnalyzeRequest,
  SubmitAnalyzeFeedbackRequest,
} from '@/types/api/feedback'
import { Feedback, feedbackSchema } from '@/types/schema/api/feedback'

const feedbackApi = api.injectEndpoints({
  endpoints: (build) => ({
    fetchFeedbackAnalyze: build.query<Feedback, FetchFeedbackAnalyzeRequest>({
      query: ({ workspaceId, ...params }) => {
        return {
          url: `/workspaces/${workspaceId}/feedback/analyze`,
          params,
        }
      },
      extraOptions: {
        dataSchema: feedbackSchema,
      },
      providesTags: [WorkspacesAPITagType.FeedbackAnalyze],
    }),
    submitAnalyzeFeedback: build.mutation<void, SubmitAnalyzeFeedbackRequest>({
      query: ({ workspaceId, feedbackType, ...body }) => {
        return {
          url: `/workspaces/${workspaceId}/feedback/${feedbackType}`,
          method: 'POST',
          body,
        }
      },
      invalidatesTags: [WorkspacesAPITagType.FeedbackAnalyze],
    }),
  }),
  overrideExisting: false,
})

export const {
  useFetchFeedbackAnalyzeQuery,
  useSubmitAnalyzeFeedbackMutation,
} = feedbackApi
